if (!customElements.get('ct-desktop-gallery-fit')) {
  customElements.define('ct-desktop-gallery-fit', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('product-images');
      this.update = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.fit());
      };
      this.observer = new ResizeObserver(this.update);
      [this.gallery, this.gallery.closest('.grid__item')?.querySelector('ct-product-breadcrumb'), this.gallery.querySelector('.product__thumbs'), document.querySelector('#SiteHeader')].filter(Boolean).forEach(el => this.observer.observe(el));
      window.addEventListener('resize', this.update);
      window.addEventListener('load', this.update);
      document.fonts?.ready.then(() => { if (this.isConnected) this.update(); });
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('resize', this.update);
      window.removeEventListener('load', this.update);
      cancelAnimationFrame(this.frame);
    }
    fit() {
      const gallery = this.gallery;
      if (!matchMedia('(min-width: 769px)').matches) {
        gallery.removeAttribute('data-ct-viewport-fit');
        gallery.style.removeProperty('--ct-gallery-main-height');
        return;
      }
      const grid = gallery.closest('.product-grid__container');
      const photos = gallery.querySelector('.product__photos');
      const breadcrumb = gallery.closest('.grid__item')?.querySelector('ct-product-breadcrumb');
      const breadcrumbHeight = breadcrumb ? breadcrumb.getBoundingClientRect().height + parseFloat(getComputedStyle(breadcrumb).marginBottom || 0) : 0;
      if (grid) grid.style.setProperty('--ct-breadcrumb-space', breadcrumbHeight + 'px');
      const top = breadcrumbHeight + (grid || gallery).getBoundingClientRect().top + scrollY + (grid && photos ? parseFloat(getComputedStyle(photos).marginTop || 0) : 0);
      if (grid) grid.style.setProperty('--ct-gallery-sticky-top', Math.max(0, Math.round(grid.getBoundingClientRect().top + scrollY)) + 'px');
      const thumbs = gallery.querySelector('.product__thumbs');
      const thumbStyle = thumbs && getComputedStyle(thumbs);
      const thumbHeight = thumbs && thumbStyle.display !== 'none' ? thumbs.getBoundingClientRect().height + parseFloat(thumbStyle.marginTop || 0) + parseFloat(thumbStyle.marginBottom || 0) : 0;
      const preview = document.querySelector('iframe[src*="preview-bar"]');
      const previewHeight = preview && getComputedStyle(preview).display !== 'none' ? Math.min(80, preview.getBoundingClientRect().height) : 0;
      const height = Math.max(64, Math.floor(Math.min(photos.getBoundingClientRect().width, innerHeight - top - thumbHeight - previewHeight - 24)));
      const value = height + 'px';
      if (gallery.style.getPropertyValue('--ct-gallery-main-height') !== value) gallery.style.setProperty('--ct-gallery-main-height', value);
      gallery.setAttribute('data-ct-viewport-fit', '');
    }
  });
}
